var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailIcon = function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875.5h-8.75c-.828 0-1.623.264-2.209.733C.331 1.702.001 2.337 0 3v6c.001.663.33 1.298.916 1.767s1.38.732 2.209.733h8.75c.829 0 1.623-.264 2.209-.733.585-.469.915-1.104.916-1.767V3c-.001-.663-.33-1.298-.916-1.767S12.704.501 11.875.5m-8.75 1h8.75c.374 0 .74.09 1.05.259.309.168.549.406.688.684l-4.787 3.83c-.352.28-.829.438-1.326.438s-.974-.157-1.326-.438l-4.786-3.83c.138-.278.378-.516.688-.684S2.75 1.5 3.125 1.5m8.75 9h-8.75c-.497 0-.974-.158-1.326-.44-.351-.28-.549-.662-.549-1.06V3.75l4.04 3.23c.587.468 1.381.731 2.21.731s1.623-.263 2.21-.731l4.04-3.23V9c0 .398-.197.78-.55 1.06-.35.282-.828.44-1.325.44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v12H0z"
  })))));
};
export default SvgEmailIcon;